export default "__VITE_ASSET__l4KZq8Ud__"